import styled from "styled-components";

export const HeaderWrapper = styled.div(({ theme }) => ({
    padding: `${theme.spacing.xSmall} ${theme.spacing.medium} ${theme.spacing.empty} ${theme.spacing.medium}`,
    textAlign: "center",
    position: "relative",
    zIndex: 100,
}));

export const CloseIconWrapper = styled.div(({ theme }) => ({
    position: "absolute",
    right: theme.spacing.xxSmall,
    bottom: "100%",
}));
